import React from "react"

import "./InsightsHeader.scss"
import DownArrow from "../DownArrow"

export default function InsightsHeader(props) {
  const { backgroundImage, title, links, color } = props
  return (
    <div
      className="InsightsHeader"
      style={{ backgroundImage: `url(${backgroundImage})`, color }}
    >
      <div className="InsightsHeaderTitle">{title}</div>
      <div className="links">
        {links.map((link) => {
          return (
            <a
              style={{ color, borderBottomColor: color }}
              href={link.url}
              key={link.url}
            >
              {link.text} <DownArrow color={color} />
            </a>
          )
        })}
      </div>
    </div>
  )
}
